import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the office clicks "Location settings" in the left rail.
 * Event: dental_portal:menu_bar:location_settings_clicked
 */
export function fireMenuBarLocationSettingsClicked(): void {
  PosthogService.getInstance().track('dental_portal:menu_bar:location_settings_clicked');
}
